import React, {Suspense} from "react";
import {Switch} from "react-router-dom";
import {LayoutSplashScreen, ContentRoute} from "../../../_metronic/layout";
import {PartnersPage as PartnersPageComponent} from './pages/PartnersPage';

export default function PartnersPage() {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                <ContentRoute path="/partners" component={PartnersPageComponent} />
            </Switch>
        </Suspense>
    );
}
